import Permission from "../Permission";
import {useMemo} from "react";

interface Props {
    permissions: string[];
    onChange: (permissions: string[]) => void;
    server: string;
}

interface Permissions {
    name: string;
    description: string;
    possibleValues: {
        value: string;
        permissions: string[];
    }[];
}

export default function TaskPermissions({permissions, onChange, server}: Props) {

    const permissionsList = useMemo(() => {
        return [
            {
                name: 'Tasks',
                description: 'Permissions related to task management.',
                possibleValues: [
                    {value: 'none', permissions: []},
                    {value: 'read', permissions: [`task.${server}.read`]},
                    {value: 'write', permissions: [`task.${server}.read`, `task.${server}.write`]},
                ]
            },
        ];
    }, [server])

    return <>
        {permissionsList.map((permission) => {
            let value = undefined;
            let score = 0;

            for (const p of permission.possibleValues) {
                if (p.permissions.every(perm => permissions.includes(perm))) {
                    const tvalue = p.value;
                    const tscore = p.permissions.length;
                    if (value === undefined || tscore > score) {
                        value = tvalue;
                        score = tscore;
                    }
                }
            }

            return <Permission
                key={permission.name}
                permission={permission.name}
                description={permission.description}
                possibleValues={permission.possibleValues.map(value => value.value)}
                value={value ?? 'none'}
                setPermission={(value: string) => {
                    const newPermissions = permission.possibleValues.find(v => v.value === value)?.permissions || [];
                    const allPermissions: string[] = [];
                    for (const p of permission.possibleValues) {
                        allPermissions.push(...p.permissions);
                    }
                    const filteredPermissions = permissions.filter(p => !allPermissions.includes(p));
                    onChange([...filteredPermissions, ...newPermissions]);

                }}
            />
        })}
    </>

}
